module.exports = __webpack_public_path__ + "static/media/benefits-for-companies.358415eb.svg";